export const THEME = Object.freeze({
  LIGHT: "THEME_LIGHT",
  DARK: "THEME_DARK",
  SYSTEM: "THEME_SYSTEM",
});

export default {};
